import { render, staticRenderFns } from "./TerminationPopup.vue?vue&type=template&id=127d5f5e&scoped=true&lang=pug"
import script from "./TerminationPopup.vue?vue&type=script&lang=ts"
export * from "./TerminationPopup.vue?vue&type=script&lang=ts"
import style0 from "./TerminationPopup.vue?vue&type=style&index=0&id=127d5f5e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127d5f5e",
  null
  
)

/* custom blocks */
import block0 from "./TerminationPopup.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FPopups%2FTerminationPopup.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports